<template>
  <!--租凭合同-->
  <div class="renting">
    <form>
      <h1 class="f-weight__500 text-center font-small title">租凭合同</h1>

      <div class="cel cel-right">
        <div class="cel-content"><input name="contractNo" v-model="form.contractNo" class="width-mini" type="text"/></div>
        <div class="cel-content f-weight__600 font-small">编号：</div>
      </div>

      <div class="all-indent">
        <div class="cel">
          <div class="cel-content">出租人：</div>
          <div class="cel-content__full"> <input name="czr" v-model="form.czr" type="text" class="width-full" /> </div>
        </div>
        <div class="cel">
          <div class="cel-content">签订地点：</div>
          <div class="cel-content__full"> <input name="address" v-model="form.address" type="text" class="width-full" /> </div>
        </div>
        <div class="cel">
          <div class="cel-content">承租人：</div>
          <div class="cel-content__full"> <input name="chengzr" v-model="form.chengzr" type="text" class="width-full" /> </div>
        </div>
        <div class="cel">
          <div class="cel-content">签订时间：</div>
          <div class="cel-content__full"> <input name="signTime" v-model="form.signTime" type="text" class="width-full" /> </div>
        </div>
      </div>

      <div>
        第一条　租赁物 <br />
        １．名称：<input name="name" v-model="form.name" type="text" class="width-medium"/> <br />
        ２．数量及相关配套设施：<input name="slpt" v-model="form.slpt" type="text" class="width-medium"/> <br />
        ３．质量状况：<input name="zlzk" v-model="form.zlzk" type="text" class="width-medium"/> <br /><br />

        第二条　租赁期限<input name="limitYear" v-model="form.limitYear" type="text" class="width-mini"/>年<input name="limitMonth" v-model="form.limitMonth" type="text" class="width-mini"/>个月<input name="limitDays" v-model="form.limitDays" type="text" class="width-mini"/>日，
        自<input name="startTime" v-model="form.startTime" type="text" class="width-medium"/>至<input name="endTime" v-model="form.endTime" type="text" class="width-medium"/> <br />
        （提示：租赁期限不得超过二十年。超过二十年的，超过部分无效）。 <br /><br />

        第三条　租赁物的用途或性质：<input name="use" v-model="form.use" type="text" class="width-medium"/> <br />
        租赁物的使用方法：<input name="useMethod" v-model="form.useMethod" type="text" class="width-medium"/> <br /><br />

        第四条　租金、租金支付期限及方式
        １．租金（大写）：<input name="moneyZh" v-model="form.moneyZh" type="text" class="width-medium"/> <br />
        ２．租金支付期限：<input name="payLimit" v-model="form.payLimit" type="text" class="width-medium"/> <br />
        ３．租金支付方式：<input name="payMethod" v-model="form.payMethod" type="text" class="width-medium"/> <br /><br />

        第五条　租赁物交付的时间、地点、方式及验收：<input name="zlAddress" v-model="form.zlAddress" type="text" class="width-medium"/> <br /><br />

        第六条　租赁物的维修 <br />
        １．出租人维修范围、时间及费用承担：<input name="czrfycd" v-model="form.czrfycd" type="text" class="width-medium"/> <br />
        ２．承租人维修范围及费用承担：<input name="cczrfycd" v-model="form.cczrfycd" type="text" class="width-medium"/> <br /><br />

        第七条　因租赁物维修影响承租人使用<input name="yxczrts" v-model="form.yxczrts" type="text" class="width-mini"/>天的，出租人应相应减少租金或延长租期。其计算方法是：
        <input name="jsfs" v-model="form.jsfs" type="text" class="width-mini"/> <br /><br />

        第八条　租赁物的改善或增设他物 <br />
        出租人<input name="sfyxzstw" v-model="form.sfyxzstw" type="text" class="width-mini"/>（是／否）允许承租人对租赁物进行改善或增设他物。改善或增设他物不得因此损坏租赁物。 <br />
        租赁合同期满时，对租赁物的改善或增设的他物的处理办法是：<input name="dqclbf" v-model="form.dqclbf" type="text" class="width-medium"/> <br /><br />

        第九条　出租人<input name="sfyxzzzlw" v-model="form.sfyxzzzlw" type="text" class="width-mini"/>（是／否）允许承租人转租租赁物。 <br />
        第十条　违约责任：<input name="wyzr" v-model="form.wyzr" type="text" class="width-medium"/> <br /><br />

        第十一条　合同争议的解决方式：本合同在履行过程中发生的争议，由双方当事人协商解决；也可由当地工商行政管理部门调解；协商或调解不成的，按下列第
        <input name="jjfsdjz" v-model="form.jjfsdjz" type="text" class="width-mini"/>种方式解决： <br /><br />
        （一）提交<input name="arbitration" v-model="form.arbitration" type="text" class="width-medium"/>仲裁委员会仲裁； <br />
        （二）依法向人民法院起诉。 <br /><br />

        第十二条　租赁期届满，双方有意续订的，可在租赁期满前<input name="xztianshu" v-model="form.xztianshu" type="text" class="width-mini"/>日续订租赁合同。 <br /><br />

        第十三条　租赁期满租赁物的返还时间为：<input name="fanhuanshijian" v-model="form.fanhuanshijian" type="text" class="width-medium"/> <br /><br />

        第十四条　其他约定事项：<input name="otherDesc" v-model="form.otherDesc" type="text" class="width-medium"/> <br /><br />
      </div>

      <ul class="sys-list-signer">
        <li>
          出租人 <br />
          住所： <br />
          <input name="chuzrzs" v-model="form.chuzrzs" class="width-full"/> <br />
          法定代表人（签名）： <br />
          委托代理人（签名）： <br />
          电话： <br />
          <input name="chuzrmobile" v-model="form.chuzrmobile" type="text" class="width-full"/>
        </li>
        <li>
          承租人 <br />
          住所： <br />
          <input name="chengzraddress" v-model="form.chengzraddress" class="width-full"/> <br />
          法定代表人（签名）： <br />
          委托代理人（签名）： <br />
          电话： <br />
          <input name="chengzurmobile" v-model="form.chengzurmobile" type="text" class="width-full"/>
        </li>
      </ul>

    </form>
  </div>
</template>

<script>
  export default {
    name: "renting",
    data() {
      return {
        form: {
          contractNo:'',
          czr:'',
          address:'',
          chengzr:'',
          signTime:'',
          name:'',
          slpt:'',
          zlzk:'',
          limitYear:'',
          limitMonth:'',
          limitDays:'',
          startTime:'',
          endTime:'',
          use:'',
          useMethod:'',
          moneyZh:'',
          payLimit:'',
          payMethod:'',
          zlAddress:'',
          czrfycd:'',
          cczrfycd:'',
          yxczrts:'',
          jsfs:'',
          sfyxzstw:'',
          dqclbf:'',
          sfyxzzzlw:'',
          wyzr:'',
          jjfsdjz:'',
          arbitration:'',
          xztianshu:'',
          fanhuanshijian:'',
          otherDesc:'',
          chuzrzs:'',
          chuzrmobile:'',
          chengzraddress:'',
          chengzurmobile:''
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../../assets/style/sysTpl";

  .renting {
    font-family: "微软雅黑";
    font-size: 16px;
    color: #666666;
  }
</style>



// WEBPACK FOOTER //
// components/sys-contract/renting.vue